var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('markdown-docs',{attrs:{"path":"terms_of_use"}}),_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/terms_jp"}},[_vm._v(" Terms of Use (Japanese) - 日本語利用規約 ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }